import React from "react";

const Spinner = (props) => {
  const className = props.size ? `spinner spinner--${props.size}` : "spinner";

  return <span className={className} style={props.dimensions} />;
};

export default Spinner;
